import { content } from '../../common/const/componentSize';

export const sideBar = {
	width: '500px',
};

export const search = {
	titleHeight: '40px',
	titleWidth: '450px',
	titleMarginLeft: 1.5,
	height: '500px',
	width: `calc(${sideBar.width} * 0.95)`,
	halfWidth: `calc((${sideBar.width} * 0.95) / 2)`,
};

export const sideBarOpenButton = {
	top: content.top,
};

export const currentCarPlaceTable = {
	width: `calc(${sideBar.width} * 0.95)`,
	maxHeight: '330px',
	minHeight: '330px',
};

export const exampleBox = {
	top: '60px',
	right: '70px',
	height: '70px',
	width: '130px',
	borderRadius: '12px',
	boxShadow: 10,
};
